import { ReactNode, useState } from "react"
import { Card, CardBody, CardHeader, Collapse } from "reactstrap"

import Icon from "@components/common/Icon"

interface IProps {
  header: ReactNode
  ariaRole?: string
  children?: ReactNode
  className?: string
  initialOpen?: boolean
  id?: string
  collapseable?: boolean // is the card acting as collapseable card or just as Card without collapse-functionality?
}
/**
 * This component provides a collapsable Card, based on ReactStrap-Card.
 */
const CollapseCard: React.FC<IProps> = ({ children, ariaRole, collapseable = true, header, className, initialOpen = false, id }: IProps) => {
  const [isOpen, setIsOpen] = useState(initialOpen)
  const toggle = () => setIsOpen(!isOpen)

  const finalClassName = ["collapsable-card", className || ""].join(" ").trim()

  return <Card role={ariaRole} id={id} className={finalClassName}>
    <CardHeader onClick={collapseable ? toggle : null}
      onKeyDown={(event) => ((event.key === "Enter") && collapseable) && toggle()}  // open the card on Enter
      tabIndex={collapseable && 0}
      aria-expanded={isOpen}
    >
      <div className="title-section">
        {header}
      </div>
      {collapseable &&
        <span className={"chevron-right" + (isOpen ? " chevron-right--toggled" : "")}>
          <Icon name="chevron-right" size={42} />
        </span>
      }
    </CardHeader>
    <Collapse isOpen={isOpen}>
      <CardBody>
        {children}
      </CardBody>
    </Collapse>
  </Card>
}

export default CollapseCard
